var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPoll = function SvgPoll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "url(#poll_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8 17.325A1.575 1.575 0 0 0 9.225 18.9v5.4a1.575 1.575 0 0 0 1.575 1.575H25.2a1.575 1.575 0 0 0 1.575-1.575V11.7a1.575 1.575 0 0 0-1.575-1.575h-3.6a1.575 1.575 0 0 0-1.575 1.575v12.6a.225.225 0 0 1-.225.225h-3.6a.225.225 0 0 1-.225-.225v-9a.225.225 0 0 1 .225-.225h3.6a.225.225 0 0 1 .225.225v-1.559a1.59 1.59 0 0 0-.225-.016h-3.6a1.575 1.575 0 0 0-1.575 1.575v2.041a1.59 1.59 0 0 0-.225-.016h-3.6Zm0 1.35a.225.225 0 0 0-.225.225v5.4a.225.225 0 0 0 .225.225h3.6a.225.225 0 0 0 .225-.225v-5.4a.225.225 0 0 0-.225-.225h-3.6ZM21.375 15.3v9a.225.225 0 0 0 .225.225h3.6a.225.225 0 0 0 .225-.225V11.7a.225.225 0 0 0-.225-.225h-3.6a.225.225 0 0 0-.225.225v3.6Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "poll_svg__a",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B983C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#834C97"
  })))));
};
export default SvgPoll;